module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_5010.b6ca4dab.png";